const safeStringify = (value) => {
    try {
        const serialized = JSON.stringify(value);
        return serialized && serialized !== "{}" ? serialized : undefined;
    }
    catch {
        return undefined;
    }
};
/**
 * Normalizes an arbitrary thrown/rejected value into an `Error`: a non-Error payload is appended to
 * the message and kept as `error.cause`.
 */
const toError = (value, fallbackMessage) => {
    if (value instanceof Error) {
        return value;
    }
    if (typeof value === "string") {
        return new Error(value);
    }
    const serialized = value === undefined || value === null ? undefined : safeStringify(value);
    const error = new Error(serialized ? `${fallbackMessage}: ${serialized}` : fallbackMessage);
    if (value !== undefined && value !== null) {
        error.cause = value;
    }
    return error;
};
export { toError };
